<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="23"
    height="24"
    viewBox="0 0 23 24"
    fill="none"
  >
    <path
      d="M0.874525 11.0242C0.874525 11.0242 0.0874954 9.87707 1.23536 9.09073C2.38184 8.3044 3.16817 9.45088 3.16817 9.45088L6.81896 14.7751C6.9448 14.5652 7.08246 14.358 7.23611 14.1536L2.16909 6.7651C2.16909 6.7651 1.38276 5.61863 2.52993 4.83229C3.6764 4.04596 4.46274 5.19244 4.46274 5.19244L9.22872 12.1429C9.40601 11.9983 9.58747 11.853 9.77449 11.7105L4.24929 3.65175C4.24929 3.65175 3.46296 2.50527 4.61013 1.71894C5.75661 0.932606 6.54294 2.07908 6.54294 2.07908L12.0681 10.1364C12.2712 10.0119 12.4721 9.90418 12.6737 9.79016L7.50935 2.25915C7.50935 2.25915 6.72301 1.11268 7.86949 0.326343C9.01597 -0.459991 9.8023 0.686485 9.8023 0.686485L15.2628 8.64994L16.093 9.86108C12.6528 12.2208 12.3254 16.66 14.2909 19.5265C14.6837 20.1001 15.2573 19.7073 15.2573 19.7073C12.8983 16.2665 13.6186 12.4002 17.0594 10.0411L16.045 4.96439C16.045 4.96439 15.6661 3.62672 17.0031 3.24711C18.3407 2.8682 18.7203 4.20587 18.7203 4.20587L19.8919 7.68493C20.3563 9.06431 20.8506 10.4388 21.5048 11.739C23.3521 15.4099 22.2488 19.9722 18.7655 22.3618C14.966 24.9669 9.77171 23.9984 7.16589 20.1995L0.874525 11.0242Z"
      fill="#D4AB88"
    />
  </svg>
</template>

<script>
export default {
  name: "IconWave",
};
</script>

<style></style>
